import { render } from "./OrganisationInviteUser.vue?vue&type=template&id=3e778536"
import script from "./OrganisationInviteUser.vue?vue&type=script&lang=js"
export * from "./OrganisationInviteUser.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__